import * as React from 'react';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

let IS_PDF: boolean;

export function renderTable(data: any, isPdf: boolean, wrap?: boolean): JSX.Element {
    data = data || {};
    IS_PDF = isPdf || false;
    const rows: any[] = data.rows || [];
    const rowStyles: any[] = data.rowStyles || [];
    const styles: any = getStyles();

    return (
        <WpdfView style={styles.table} nowrap={!wrap} pdf={isPdf}>
            {rows.map((row: any, rowIndex: number) =>
                <WpdfView style={styles.wrapper} pdf={isPdf}>
                    <WpdfView key={`row-${rowIndex}`} style={styles.row} nowrap pdf={isPdf}>
                        {(rows[rowIndex] || []).map((col: any, colIndex: number) => {
                            const style: any = {
                                ...getStyle((rowStyles[rowIndex] || [])[colIndex]), ...rowIndex && { marginTop: -1 },
                                ...colIndex && { marginLeft: -1 }
                            };
                            return (
                                <WpdfView
                                    key={`col-${colIndex}`}
                                    style={{ ...styles.col, ...(style.flexBasis && { flexBasis: style.flexBasis }) }}
                                    pdf={isPdf}
                                >
                                    <WpdfView style={{ ...styles.cell, ...style }} pdf={isPdf}>
                                        <WpdfText
                                            style={{
                                                margin: 'auto', ...((!style.textAlign || isPdf) && { marginLeft: 0 }),
                                                ...(style.textAlign === 'right' && !isPdf && { marginRight: 0 }),
                                                ...(style.verticalAlign === 'top' && { marginTop: 0 }),
                                                ...(style.verticalAlign === 'bottom' && { marginBottom: 0 })
                                            }}
                                            pdf={isPdf}
                                        >
                                            {col || ''}
                                        </WpdfText>
                                    </WpdfView>
                                </WpdfView>
                            );
                        })}
                    </WpdfView>
                </WpdfView>
            )}
        </WpdfView>
    );
}

function getStyle(data: any): any {
    const css: any = !Array.isArray(data) && typeof data === 'object' && data !== null
        ? data
        : (Array.isArray(data) && (Array.isArray(data[0]) || typeof data[0] === 'string') && !Array.isArray(data[1])
            && typeof data[1] === 'object' && data[1] !== null
            ? data[1] : {}
        );
    const props: string[] = typeof data === 'string'
        ? [data]
        : (Array.isArray(data) && data.every((item) => typeof item === 'string')
            ? data
            : (Array.isArray(data) && Array.isArray(data[0]) && data[0].every((item) => typeof item === 'string')
                ? data[0]
                : (Array.isArray(data) && typeof data[0] === 'string' ? [data[0]] : [])
            )
        );
    const styles: any = getStyles();
    let style: any = {};

    props.forEach((prop: any) => style = { ...style, ...(styles[prop] || {}) });
    style = { ...style, ...css };

    return style;
}

function getStyles(): any {
    return {
        table: {
            fontSize: '9pt',
            maxWidth: 720,
            marginBottom: '8pt'
        },
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box'
        },
        row: {
            color: 'black',
            backgroundColor: 'white',
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            boxSizing: 'border-box'
        },
        col: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column'
        },
        cell: {
            textAlign: 'left',
            padding: IS_PDF ? 2 : 4,
            border: '1pt solid black',
            whiteSpace: 'pre-line',
            display: 'flex',
            flex: 1,
            boxSizing: 'border-box'
        },
        center: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        right: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        top: {
            verticalAlign: 'top'
        },
        bottom: {
            verticalAlign: 'bottom'
        },
        bold: {
            ...(IS_PDF && { fontFamily: 'Helvetica-Bold' }),
            fontWeight: 'bold'
        },
        italic: {
            ...(IS_PDF && { fontFamily: 'Helvetica-Oblique' }),
            fontStyle: 'italic'
        },
        underline: {
            textDecoration: 'underline'
        },
        head: {
            backgroundColor: '#95b3d7'
        }
    };
}
